import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid2,
  IconButton,
  Typography,
} from "@mui/material";
import PrimaryIcon from "Components/Common/PrimaryIcon";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { ReactComponent as CloseIcon } from "Assets/Icons/Home/CloseIcon.svg";
import { ReactComponent as CallBackICon } from "Assets/Icons/Referral/CallBackIcon.svg";
import { ReactComponent as FormDetailIcon } from "Assets/Icons/Referral/FormDetailIcon.svg";
import { ReactComponent as CopyIcon } from "Assets/Icons/Referral/CopyIcon.svg";
import { ReactComponent as ShareIcon } from "Assets/Icons/Referral/ShareIcon.svg";
import { toast } from "react-toastify";


const StartReferringDialog = ({ open, setOpen, currentTab, handleWhatsAppShare = () => {}, handleAddUserRequest = () => {},  addFriend = () => {} }) => {
  const dispatch = useDispatch();

  const handleClose = () => {
    setOpen(false);
  };

  const { ReferralReward, Translation } = useSelector((state) => ({
    ReferralReward: state.ReferralReward.referralReward,
    Translation: state.Translation.translation?.Referral || {},
  }));

  const handleCopy = () => {
    navigator.clipboard.writeText(ReferralReward[currentTab]?.ReferralCode).then(() => {
      toast.success(Translation?.Copied)
    }).catch(err => {
      console.error('Failed to copy: ', err);
    });
  };


  return (
    <Dialog fullWidth maxWidth="md" open={open} onClose={() => handleClose()}>
      <DialogTitle>
        {Translation?.QuickWayReferringYourFriend}
        <IconButton onClick={() => handleClose()}>
          {" "}
          <PrimaryIcon
            icon={CloseIcon}
            color="white"
            height="14px"
            width="14px"
          />{" "}
        </IconButton>{" "}
      </DialogTitle>
      <DialogContent>
        <Grid2
          sx={(theme) => ({
            "&>div": {
              border: `1px solid ${theme.palette.border.blue}`,
              borderRadius: "8px",
              padding: "16px",
              display: "flex",
              flexDirection: "column",
              gap: "8px",
              alignItems: "start",
              "& button": {
                marginTop: "auto",
              },
            },
          })}
          container
          spacing={2}
        >
          <Grid2 size={6}>
            <Box
              display={"flex"}
              alignItems={"center"}
              justifyContent={"space-between"}
              width={"100%"}
            >
              <Typography fontWeight={500}>{Translation?.RequestACallback}</Typography>
              <PrimaryIcon
                icon={CallBackICon}
                variant="light"
                height="30px"
                width="30px"
              />
            </Box>
            <Typography color="secondary.light">
              {Translation?.ReferralManagerCallYou}
            </Typography>
            <Button variant="contained" color="error" onClick={handleAddUserRequest}> 
              {Translation?.WantACallback}
            </Button>
          </Grid2>
          <Grid2 size={6}>
            <Box
              display={"flex"}
              alignItems={"center"}
              justifyContent={"space-between"}
              width={"100%"}
            >
              <Typography fontWeight={500}>{Translation?.AddFriendDetails}</Typography>
              <PrimaryIcon
                icon={FormDetailIcon}
                variant="light"
                height="30px"
                width="30px"
              />
            </Box>
            <Typography color="secondary.light">
              {Translation?.ShareFriendDetails}
            </Typography>
            <Button
              onClick={() => addFriend()}
              variant="contained"
              color="error"
            >
              {Translation?.AddFriendDetails}
            </Button>
          </Grid2>{" "}
        </Grid2>
        <Typography
          display={"flex"}
          margin={"10px 0px 20px 0px"}
          color="secondary.light"
        >
          {Translation?.DoNotSpamLearner}
        </Typography>
        <Divider />
      </DialogContent>
      <DialogActions align="right">
        <Typography marginRight={"auto"}>
          {Translation?.ShareReferralCode}
        </Typography>
        <Button
          endIcon={<PrimaryIcon icon={CopyIcon} width="16px" height="16px" />}
          variant="outlined"
          color="secondary"
          onClick={handleCopy}
        >
          {ReferralReward[currentTab]?.ReferralCode}
        </Button>
        <Button
          variant="outlined"
          color="secondary"
          startIcon={
            <PrimaryIcon icon={ShareIcon} width="16px" height="16px" />
          }
          onClick={handleWhatsAppShare}
        >
          {Translation?.ShareOnWhatsapp}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default StartReferringDialog;
